module.exports = __webpack_public_path__ + "static/media/screen-left.4f49d257.webp";